import { ButtonModule } from 'primeng/button';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogModule,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationDialogService } from '../../../../../../shared/services/confirmation-dialog.service';
import { DynamicRoleCriteriaService } from '../../../../../../shared/services/dynamic-role-criteria.service';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { PipesModule } from '../../../../../../shared/pipes/pipes.module';
import { HelperService } from '../../../../../../shared/services/helper.service';

@Component({
  selector: 'dynamic-table',
  standalone: true,
  imports: [
    ButtonModule,
    IconFieldModule,
    InputIconModule,
    TableModule,
    CommonModule,
    DynamicDialogModule,
    TagModule,
    TooltipModule,
    PipesModule
  ],
  templateUrl: './dynamic-table.component.html',
  providers: [DialogService, DynamicDialogRef, DynamicDialogConfig],
  encapsulation: ViewEncapsulation.None,
})
export class DynamicTableComponent {
  @Input() dynamicCriteria: [] = [];
  @Input() title: string = '';
  @Input() isEditingEnabled: boolean = true;
  @Output() refreshEvent = new EventEmitter<void>();

  ref: DynamicDialogRef | undefined;
  constructor(
    private confirmationDialogService: ConfirmationDialogService,
    private router: Router,
    public config: DynamicDialogConfig,
    private dynamicCriteriaService: DynamicRoleCriteriaService,
    public helperService: HelperService
  ) {}

  onArchive($event: Event, criteria: any) {
    $event.stopPropagation();
    this.confirmationDialogService.confirm({
      target: $event.target as EventTarget,
      message:'Are you sure you want to ' + (!criteria.isArchived ? 'deactivate? <br> Doing so will make this skill unavailable to your firm and its candidates.' : `activate ${criteria.name}?`),  
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      accept: () => {
        if(criteria.isArchived) {
          this.dynamicCriteriaService
            .unarchiveDynamicRoleCriteria(criteria._id)
            .subscribe({
              next: () => {
                this.refreshEvent.emit();
              },
            });
        }else {
          this.dynamicCriteriaService
            .archiveDynamicRoleCriteria(criteria._id)
            .subscribe({
              next: () => {
                this.refreshEvent.emit();
              },
            });
        }
      },
    });
  }

  onDelete($event: Event, criteria: any) {
    $event.stopPropagation();
    this.confirmationDialogService.confirm({
      target: $event.target as EventTarget,
      message: 'Are you sure you want to delete ' + criteria?.name + '? <br> Doing so will permanently remove the skill from your firm.',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      accept: async () => {
        const res = await this.dynamicCriteriaService.getCriteriaAssociations(criteria?._id);
        if(res.reviewersCount > 0) {
          this.showReviewersConfirmationModal(criteria, res.reviewersCount, $event);
        } else {
          this.deleteCriteria(criteria?._id);
        }
      },
    });
  }

  goToEdit($event: Event, criteria?: any) {
    this.router.navigateByUrl(
      `client/settings/dynamic-criteria/edit/${criteria._id}`,
      {
        state: {
          data: criteria,
        },
      }
    );
  }

  showReviewersConfirmationModal(credential: any, reviewersCount: number, $event: Event): void {
    this.confirmationDialogService.confirm({
      target: $event.target as EventTarget,
      message: `There are currently ${reviewersCount > 1 ? reviewersCount + ' candidates' : '1 candidate'} with this skill in their profile.<br> ${credential?.name} will be removed from their profile. Are you sure you want to continue?`,
      header: 'Delete skills and experience',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Delete',
      rejectLabel: 'Cancel',
      accept: () => {
        this.deleteCriteria(credential?._id);
      }
    });
  }

  deleteCriteria(id: string): void {
    this.dynamicCriteriaService.deleteDynamicRoleCriteria(id).subscribe({
      next: () => {
        this.refreshEvent.emit();
      },
    });
  }
}
